<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='申请开票'">
    <div v-if="ispiao==1">
      <img class="piao-bj" src="../../assets/top-bg.png" alt="">

      <div class="piao-tit" v-if="piaotype==1">
        <h3>已开票</h3>
        <p>该订单已开具1张发票</p>
      </div>
      <div class="piao-tit" v-else>
        <h3>申请中</h3>
        <p>商家正在处理，如有问题请咨询商家</p>
      </div>
      <div class="piao-box">
        <div class="info border-box">
          <div class="tit">开票详细</div>

          <div class="item box">
            <div class="l">发票抬头</div>
            <div class="flex r hide">{{title}}</div>
          </div>
          <div class="item box">
            <div class="l">税号</div>
            <div class="flex r hide">{{num}}</div>
          </div>
          <div class="item box">
            <div class="l">接收邮箱</div>
            <div class="flex r hide">{{email}}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="info border-box">
        <div class="tit">开票信息</div>
        <div class="item box">
          <div class="l">订单编号</div>
          <div class="flex r hide">{{ordernum}}</div>
        </div>

        <div class="item box">
          <div class="l">发票抬头</div>
          <div class="flex r">
            <input type="text" placeholder="需要开票的企业名称" v-model="title">
          </div>
        </div>
        <div class="item box">
          <div class="l">税号</div>
          <div class="flex r">
            <input type="text" placeholder="纳税人识别号" v-model="num">
          </div>
        </div>
        <div class="item box">
          <div class="l">接收邮箱</div>
          <div class="flex r">
            <input type="text" placeholder="电子发票接收邮箱" v-model="email">
          </div>
        </div>
      </div>

      <div class="btn linear" @click="uploadPiaoFun">申请开票</div>

    </div>



    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getPiao,upPiao,piaoDesc} from "@/service/getData";
  import {wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '', //订单编码
        ispiao: this.$route.query.ispiao || '', //是否申请了开票 0未申请发票  1已申请发票
        piaotype: this.$route.query.piaotype || '', //是否开票成功 0 发票未发送  1 发票已发送
        title: '',
        num: '',
        email: '',
        loadEnd: false, //数据加载结束则赋值为true
        P400: 0, //系统维护中
      }
    },
    computed: {},

    created(){

      this.piaoDescFun()
    },
    methods: {
      //获取历史开票信息
      async getPiaoFun(){
        let res = await getPiao({
          ordernum: this.ordernum
        })
        if (res.errcode == "00000") {
          this.title = res.data.title || '';
          this.num = res.data.num || '';
          this.email = res.data.email || '';
        }
      },

      //获取开票详情
      async piaoDescFun(){
        let res = await piaoDesc({
          ordernum: this.ordernum
        });
        if (res.errcode == "00000") {
          this.title = res.data.piaotitle || '';
          this.num = res.data.piaonum || '';
          this.email = res.data.email || '';
          this.ispiao = res.data.ispiao || 0;
          this.piaotype = res.data.piaotype || 0;
          if(!res.data.ispiao){
            this.getPiaoFun()
          }
        }
      },

      //申请开票
      uploadPiaoFun: function (){
        var self = this;
        if(!this.title){
          this.$toast('请填写需要开票的企业名称');
          return
        }
//        if(!this.num){
//          this.$toast('请填写纳税人识别号');
//          return
//        }
        if(!this.email){
          this.$toast('请填写电子发票接收邮箱');
          return
        }
        this.$confirm({
          title: '提示',
          content: '<p class="tl">发票抬头：'+self.title +'</p><p class="tl">税号：'+self.num +'</p><p class="tl">接收邮箱：'+self.email +'</p>',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.upPiaoFun()
          }
        }).catch(function(res){
          if(res == 'success') {
            self.upPiaoFun()
          }
        })
      },
      //提交开票
      async upPiaoFun(ind){
        let res = await upPiao({
          ordernum: this.ordernum,
          title: this.title,
          num: this.num || '',
          email: this.email
        });
        if(res.errcode == "00000"){
          this.$toast('申请成功')
          this.piaoDescFun()
        }else{
          this.$toast(res.errmsg)
        }
      },

    },
    watch: {},
    components: {
        P400
    }
  }

</script>

<style scoped>
  .page{min-height: 100vh; padding: .2rem .3rem 1.3rem;background-color:#f2f2f2}
  .piao-bj{position: absolute;left: 0;top: 0;right: 0;width: 100%;height: 22vh;}
  .piao-tit{position: relative; z-index: 1; padding-top: .25rem;}
  .piao-tit h3{font-size: .32rem; color: #fff;}
  .piao-tit p{ margin-top: .1rem; font-size: .26rem; color: #fff;}
  .piao-box{ margin-top: .34rem; }

  .info{position:relative;margin-top:.2rem;padding: .1rem .3rem;background: #fff;border-radius: .13rem;}
  .info:first-child{margin-top: 0;}
  .item{padding: .18rem 0;line-height: .54rem;border-bottom:1px solid #e3e3e3;}
  .item:last-child{border-bottom: none;}
  .info .tit{font: .32rem/1.14rem "Microsoft YaHei";color: #666;}
  .info:first-child .item .l{color:#666;}

  .item .l{width: 1.5rem;font: .32rem/.54rem "Microsoft YaHei";color: #333;}
  .item .r{font: .28rem/.54rem "Microsoft YaHei";color: #222;text-align: right;}
  .item input{display:inline-block;width:100%;text-align: right;font-size: .28rem;}

  .btn{width:89%; height: .68rem; line-height: .68rem; margin: .3rem auto 0;}
</style>



// WEBPACK FOOTER //
// src/page/home/piao.vue